import React from 'react';
import { Link } from "react-router-dom";
import personf from './images/personf.png';
import './styles/sidebar.css';
import firebase, { auth, provider } from './firebase/firebase.js';
import Authentication from './authentication.js'

export default class SideBar extends React.Component {
    constructor() {
        super();
        this.state =
        {
            user: null
        }
        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);

    }
    logout() {
        auth.signOut()
            .then(() => {
                this.setState({
                    user: null
                });
            });
    }
    login() {
        auth.signInWithPopup(provider)
            .then((result) => {
                const user = result.user;
                this.setState({
                    user
                });
            });
    }

    componentDidMount() {
        auth.onAuthStateChanged((user) => {
            if (user) {
                this.setState({ user });
            }
        });
    }
    render() {
        return (
            <div>
                {this.state.user ?
                    <div id="sidebarContainer">
                        <div className="row-fluid">
                            <Link style={{ textDecoration: 'none' }} to="/">
                                <button className="btn btn-light btn-block sideLinkButton">
                                    Home
                                </button>
                            </Link>
                            <Link style={{ textDecoration: 'none' }} to="/discover/">
                                <button className="btn btn-light btn-block sideLinkButton">
                                    Discover
                                </button>
                            </Link>
                            <Link style={{ textDecoration: 'none' }} to="/sessions/">
                                <button className="btn btn-light btn-block sideLinkButton">
                                    Sessions
                                </button>
                            </Link>
                            <Link style={{ textDecoration: 'none' }} to="/credits/">
                                <button className="btn btn-light btn-block sideLinkButton">
                                    Credits
                                </button>
                            </Link>
                            <Link style={{ textDecoration: 'none' }} to="/social/">
                                <button className="btn btn-light btn-block sideLinkButton">
                                    Social
                                </button>
                            </Link>
                            <Link style={{ textDecoration: 'none' }} to="/profile/">
                                <button className="btn btn-light btn-block sideLinkButton">
                                    Profile
                                </button>
                            </Link>
                        </div>
                    </div>
                    :
                    <div className='wrapper'>
                        <p>You must be logged in to see skills.</p>
                    </div>
                }
            </div>
        );
    }
}